<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.member_list") }}
  .section-body
    .row
      .col-12
        .card.mb-0.card-primary
          .card-header
            .row.w-100
              .form-group.col-12.mb-1
                .d-inline-block.mr-2
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.refresh') }}
                    b-input-group-text(slot="append")
                      label.custom-switch
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="refreshOn" @change="toggleRefresh()")
                        span.custom-switch-indicator
                    b-input-group-text(slot="append")
                      b-input(v-model="refreshInterval" type="range" min="1" max="5")
                    b-input-group-text(slot="append")
                      span {{ refreshInterval }} s
              .form-group.col-3.mb-1
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t('ui.status') }}
                  b-form-select(v-model="memberStatus" :disabled="loading" size="sm" @change="getCpiMemberList(true)")
                    option(value="") {{ $t('ui.all') }}
                    option(value="FOLLOW-UP") {{ $t('ui.follow_up') }}
                    option(value="INTERESTED") {{ $t('ui.interested') }}
                    option(value="INVALID") {{ $t('ui.invalid') }}
                    option(value="NON-PICKUP") {{ $t('ui.non_pickup') }}
                    option(value="REJECTED") {{ $t('ui.rejected') }}
              .form-group.col-3.mb-1(v-if="['MYR'].includes(getCurrencyCode) || this.isUat")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-search
                  DebounceInput(autofocus type="number" v-model="searchID" :placeholder="$t('message.search_by_id')" @enter="getCpiMemberList(true)" size="sm")
              .form-group.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getCpiMemberList(true)"
                  variant="primary"
                  size="sm"
                )
              .form-group.col-12(v-if="isEditAccess && !['MYR'].includes(getCurrencyCode)")
                b-button(type="button" variant="info" size="sm" @click="onGroupCall(null)" :disabled="loading")
                  i.fas.fa-phone-volume
                  span.ml-2 {{ $t("ui.multi_call") }}

          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12 
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="20%")
                          span(:title="$t('ui.name')") {{ $t("ui.name") }}
                        th(width="20%")
                          span(:title="$t('ui.phone')") {{ $t("ui.phone") }}
                        th(width="14%")
                          span(:title="$t('ui.email')") {{ $t('ui.email') }}
                        th.text-center(width="10%" @click="sortOrder('status')")
                          span(:title="$t('ui.status')") {{ $t("ui.status") }}
                          .float-right
                            i(:class="changeSortKey('status')")
                        th.text-center(width="10%")
                          span(:title="$t('ui.tele_status')") {{ $t("ui.tele_status") }}
                        th.text-right(width="12%")
                          span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
                        th.text-center(width="8%" v-if="isEditAccess && !['MYR'].includes(getCurrencyCode)")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                    tbody.clusterize-content
                      tr(v-if="cpiMemberList.length == 0")
                        td(:colspan="8").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in cpiMemberList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span.badge.badge-info.mr-2 {{ item.id }}
                          span(:title="item.fullname") {{ item.fullname }}
                        td
                          span(:title="item.phone") {{ item.phone }}
                        td
                          small.d-block(:title="item.email") {{ item.email }}
                          small.d-block(:title="item.email2") {{ item.email2 }}
                          small.d-block(:title="item.email3") {{ item.email3 }}
                        td.text-center
                          span(:title="item.status" :class="$helpers.badgeClass(item.status)") {{ item.status }}
                        td.text-center
                          span(:title="item.tele_status") {{ item.tele_status }}
                        td.text-right
                          template(v-if="item.status_update != null")
                            span.d-block(:title="item.status_by") {{ item.status_by }}
                            span.d-block(:title="$moment(item.status_update).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.status_update).format('YYYY-MM-DD, HH:mm:ss') }}
                          span(v-else) -
                        td.text-center(v-if="isEditAccess && !['MYR'].includes(getCurrencyCode)")
                          span
                            a.fas.fa-phone-volume.btn.btn-ssm.btn-icon.btn-info(
                              v-if="item.phone == null && item.tele_calling != 1"
                              :class="{ 'disabled' : loading }"
                              href="javascript:void(0)"
                              :disabled="loading"
                              @click="onGroupCall(item)"
                              :title="$t('ui.call')"
                              )
                          span(v-if="item.phone != null && !item.is_taken")
                            a.fa.fa-plus.btn.btn-ssm.btn-icon.btn-primary(
                              :class="{ 'disabled' : loading }"
                              href="javascript:void(0)"
                              :disabled="loading"
                              @click="onAddCustom(item)"
                              :title="$t('ui.add_custom')"
                              )

  template(v-if="!['MYR'].includes(getCurrencyCode)")
    .section-header.mt-3
      h1 {{ $t("ui.on_call_list") }}
    .section-body
      .row
        .col-12
          .card.mb-0.card-secondary
            .card-header
              .row.w-100
                .form-group.col-12.mb-1
                  .d-inline-block.mr-2
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        span {{ $t('ui.refresh') }}
                      b-input-group-text(slot="append")
                        label.custom-switch
                          input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="refreshOnOnCall" @change="toggleRefreshOnCall()")
                          span.custom-switch-indicator
                      b-input-group-text(slot="append")
                        b-input(v-model="refreshIntervalOnCall" type="range" min="1" max="5")
                      b-input-group-text(slot="append")
                        span {{ refreshIntervalOnCall }} s
                .form-group.col-12.mb-1
                  SubmitButton(
                    :loading="loading2"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getCpiMemberOnCallList(true)"
                    variant="primary"
                    size="sm"
                  )
            .card-body
              .row
                .col-10.mb-1
                  b-pagination.float-left(
                    size="sm"
                    hide-ellipsis
                    :total-rows="totalRowOnCall"
                    :per-page="getPageSizeCpiOnCall"
                    v-model="currentPageOnCall"
                    @input="changedPage($event)")
                .col-2.mb-1
                  b-input-group(:prepend="$t('ui.page_size')" size="sm")
                    b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSizeCpiOnCall" @input="changedPageSizeCpiOnCall" size="sm")
                .col-12
                  .clusterize-scroll.table-responsive
                    table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                      thead.thead-light
                        tr
                          th.text-center(width="3%")
                            span #
                          th(width="20%")
                            span(:title="$t('ui.name')") {{ $t("ui.name") }}
                          th(width="20%")
                            span(:title="$t('ui.phone')") {{ $t("ui.phone") }}
                          th(width="14%")
                            span(:title="$t('ui.email')") {{ $t('ui.email') }}
                          th.text-center(width="10%" @click="sortOrder('status')")
                            span(:title="$t('ui.status')") {{ $t("ui.status") }}
                            .float-right
                              i(:class="changeSortKey('status')")
                          th.text-center(width="10%")
                            span(:title="$t('ui.tele_status')") {{ $t("ui.tele_status") }}
                          th.text-right(width="12%")
                            span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
                          th(width="8%")
                            span(:title="$t('ui.call_type')") {{ $t("ui.call_type") }}
                      tbody.clusterize-content
                        tr(v-if="cpiMemberOnCallList.length == 0")
                          td(:colspan="8").text-center
                            span {{ $t('message.no_data_available') }}
                        tr(v-for="(item, index) in cpiMemberOnCallList")
                          td.text-center
                            span(:title="((currentPage - 1) * getPageSizeCpiOnCall + index + 1)") {{ ((currentPage - 1) * getPageSizeCpiOnCall + index + 1) }}
                          td
                            span.badge.badge-info.mr-2 {{ item.id }}
                            span(:title="item.fullname") {{ item.fullname }}
                          td
                            span(:title="item.phone") {{ item.phone }}
                          td
                            small.d-block(:title="item.email") {{ item.email }}
                            small.d-block(:title="item.email2") {{ item.email2 }}
                            small.d-block(:title="item.email3") {{ item.email3 }}
                          td.text-center
                            template(v-if="isEditAccess")
                              b-form-select.text-uppercase(v-model="item.status" @change="changedStatus(item, $event)" size="sm" :disabled="loading")
                                option(:value="null" disabled) TBC
                                option(
                                  v-for="option in getFilteredStatusList(item.status)"
                                  :key="option.status_name"
                                  :value="option.status_name"
                                ) {{ option.status_name }}

                            template(v-else)
                              span(:title="item.status" :class="$helpers.badgeClass(item.status)") {{ item.status }}
                          td.text-center
                            span(:title="item.tele_status") {{ item.tele_status }}
                          td.text-right
                            template(v-if="item.status_update != null")
                              span.d-block(:title="item.status_by") {{ item.status_by }}
                              span.d-block(:title="$moment(item.status_update).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.status_update).format('YYYY-MM-DD, HH:mm:ss') }}
                            span(v-else) -
                          td
                            span(:title="item.call_type") {{ item.call_type }}

    groupcall(ref="groupcall" :customerInfo="selectedMember" @clicked="afterGroupCall" @failed="handleFailed")
    addcustom(ref="addcustom" :customerInfo="selectedMember" @clicked="afterAddCustom" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import groupcall from "@/components/cpi/groupCall.vue";
import addcustom from "@/components/cpi/addCustom.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    groupcall,
    addcustom
  },
  data: () => ({
    loading: false,
    loading2: false,
    filterBy: "",
    cpiMemberList: [],
    currentPage: 1,
    totalRow: 0,
    currentPageOnCall: 1,
    totalRowOnCall: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "",
    sortType: "",
    selectedMember: null,
    statusList: [],
    memberTimer: null,
    refreshOn: false,
    refreshInterval: 5,
    refreshChange: "",
    onCallTimer: null,
    refreshOnOnCall: false,
    refreshIntervalOnCall: 5,
    refreshChangeOncall: "",
    memberStatus: "",
    cpiMemberOnCallList: [],
    searchID: "",
    isUat: config.isUat
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    getPageSizeCpiOnCall() {
      return this.$store.getters.pageSizeCpiOnCall;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_cpi");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  destroyed: function() {
    if (this.memberTimer) {
      clearTimeout(this.memberTimer);
    }
    if (this.onCallTimer) {
      clearTimeout(this.onCallTimer);
    } 
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      this.getCpiMemberStatusLookupList();
    }
  },
  methods: {
    toggleRefresh: function() {
      this.startRefreshTimer();
    },
    toggleRefreshOnCall: function() {
      this.startRefreshTimerOnCall();
    },
    startRefreshTimer: function() {
      if (this.memberTimer) {
        clearTimeout(this.memberTimer);
      }
      if (this.refreshOn) {
        this.getCpiMemberList();
        this.memberTimer = setTimeout(() => {
          this.startRefreshTimer();
        }, this.refreshInterval * 1000);
      } else {
        this.refreshChange = "STOPPED";
      }
    },
    startRefreshTimerOnCall: function() {
      if (this.onCallTimer) {
        clearTimeout(this.onCallTimer);
      }
      if (this.refreshOnOnCall) {
        this.getCpiMemberOnCallList();
        this.onCallTimer = setTimeout(() => {
          this.startRefreshTimerOnCall();
        }, this.refreshIntervalOnCall * 1000);
      } else {
        this.refreshChangeOnCall = "STOPPED";
      }
    },
    getFilteredStatusList(status) {
      const current = this.statusList.find(info => info.status_name === status)
      if (!current) return this.statusList
      return current.reveal_info
        ? this.statusList.filter(info => info.reveal_info)
        : this.statusList
    },
    onGroupCall(e) {
      this.selectedMember = e;
      this.$refs.groupcall.$refs.groupCall.show();
    },
    afterGroupCall() {
      this.getCpiMemberList();
      this.$helpers.showDialog(this.$t("ui.call"), this.$t("message.will_start_call_now"), "success");
    },
    onAddCustom(e) {
      this.selectedMember = e;
      this.$refs.addcustom.$refs.addCustom.show();
    },
    afterAddCustom() {
      this.getCpiMemberList();
      this.$helpers.showDialog(this.$t("ui.add_custom"), this.$t("message.success"), "success");
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getCpiMemberList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getCpiMemberStatusLookupList: function() {
      let url = config.cpiMemberStatusLookupUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.statusList = response.data.dt;
                this.getCpiMemberList(true);
                if(!['MYR'].includes(this.getCurrencyCode) || this.isUat) {
                  this.getCpiMemberOnCallList(true);
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getCpiMemberList: function(isSearch) {
      let url = config.cpiMemberListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.accountID,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
        member_status: this.memberStatus
      };

      if(['MYR'].includes(this.getCurrencyCode) || this.isUat) {
        json.id = this.searchID
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.cpiMemberList = response.data.dt;
                this.totalRow = this.cpiMemberList.length > 0 ? this.cpiMemberList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getCpiMemberOnCallList: function(isSearch) {
      let url = config.cpiMemberOnCallListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.accountID,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPageOnCall,
        page_size: this.getPageSizeCpiOnCall
      };

      this.loading2 = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading2 = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.cpiMemberOnCallList = response.data.dt;
                this.totalRowOnCall = this.cpiMemberOnCallList.length > 0 ? this.cpiMemberOnCallList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading2 = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getCpiMemberList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getCpiMemberList();
    },
    changedPageSizeCpiOnCall: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeCpiOnCall", pageSize);
      this.currentPageOnCall = 1;
      this.getCpiMemberOnCallList(true);
    },
    changedPageOnCall: function(pageNo) {
      this.currentPageOnCall = pageNo;
      this.getCpiMemberOnCallList();
    },
    changedStatus: function(info, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_cpi_member_status_confirm", { name: info.id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(info, eventStatus);
          } else {
            this.getCpiMemberOnCallList()
          }
        });
    },
    confirmStatus: function(info, status) {
      let url = config.cpiMemberStatusUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        cpi_id: info.cpi_id,
        id: info.id,
        new_status: status,
        on_call_id: info.on_call_id
      };

      this.feedback.success = true;
      this.loading2 = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading2 = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
                this.getCpiMemberList()
                this.getCpiMemberOnCallList()
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) {
                  this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  this.getCpiMemberOnCallList()
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading2 = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
